var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},[_c('div',_vm._l((_vm.alerts),function(alert,index){return _c('alert',{key:index,attrs:{"alert":alert,"index":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }